import { createApp } from "vue"
import type { Plugin } from "vue"
import { createPinia } from "pinia"
import App from "./App.vue"
import { router } from "./router"
import vuetify from "./plugins/vuetify"
import "@/scss/style.scss"
import { PerfectScrollbarPlugin } from "vue3-perfect-scrollbar"
import VueScrollTo from "vue-scrollto"
import i18n from "./utils/i18n"
import VueChartkick from "vue-chartkick"
import "chartkick/chart.js"
import { scheduleNonCriticalAssets } from "./utils/lazyAssets"

const app = createApp(App)

app.use(router)
app.use(createPinia())
app.use(vuetify)
app.use(PerfectScrollbarPlugin)
app.use(i18n)
app.use(VueChartkick as unknown as Plugin)
app.use(VueScrollTo, {
  duration: 1000,
  easing: "ease",
})

app.mount("#app")

scheduleNonCriticalAssets()
